import { createContext } from 'react';

// The authoritative active organization, published by OrgBoundary (_app.jsx).
//
// Route guards must NOT read the active org from Clerk's `useOrganization()`
// hook: that hook lags a same-session `setActive()` switch (a documented Clerk
// reactivity gap — see OrgBoundary's header comment and InitPage reading
// `window.Clerk.organization` directly). During that lag the destination
// overview's org-type gate (PrivateRoute) sees the OLD org type and bounces a
// type-changing switch (operator↔declarant) to /not-found.
//
// OrgBoundary already tracks the active org from Clerk's authoritative
// imperative channel (`clerk.addListener` → `resources.organization`), which is
// fresh immediately after the switch. It mirrors that into this context so the
// guard reads a source that never lags.
//
// Default `null` is a "no provider" sentinel: `useAuthReadiness` falls back to
// the `useOrganization()` hook when rendered outside OrgBoundary (unit tests,
// any future out-of-boundary usage).
export const ActiveOrgContext = createContext(null);
